import React from "react";
import cx from "classnames";
import _ from "lodash";
import MvpsImage from "../../../../assets/images/tot/mvps.png";

const MultiplePerson = (props) => {
  const {
    activeGuesser,
    color = "",
    imageClassName = "",
    players_with_max_score,
  } = props;
  const profileImg = activeGuesser ? _.get(activeGuesser, "profile_image") : "";
  const activeUserName = activeGuesser
    ? _.get(activeGuesser, "display_name")
    : "";
  let players_data = [];
  if (players_with_max_score.length > 3) {
    players_data = players_with_max_score.slice(0, 3);
  } else {
    players_data = [...players_with_max_score];
  }
  players_data.sort((a, b) => {});
  return (
    <div className="mutiple-person-wrapper">
      <div className="tot-persons-group">
        {players_data &&
          players_data.map((player) => (
            <div className="tot-person">
              <img
                className={cx("person-img", imageClassName)}
                src={player?.profile_image}
              />
            </div>
          ))}
      </div>

      <div className="tot-person-bg">
        <div className="multiple-person-name">
          {players_data &&
            players_data.map((player) => <p>{player?.display_name}</p>)}
        </div>

        {<img src={MvpsImage} alt="Guesser" />}
      </div>
    </div>
  );
};

export default MultiplePerson;
